import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer, OrderingBox } from '../../Reusable'

import FadeIn from 'react-fade-in';
 
const { useHistory } = require('react-router-dom')

interface Props {
  
}
const AdminsScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)

  const onFetch = async () => {
    try {
      const list = await Fire.list(Fire.store().collection('admins'))
      for (const item of list) {
        item.role_col = item.role === 'super_admin' ? 'Super administrateur' : 'Administrateur'
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
      }
      return list
    } catch (err) {
      setError("Impossible de charger les admins")
      console.warn(err)
    }
    return []
  }

  const onDelete = async (item: any, refresh: any) => {
    try {
      await Fire.store().collection('admins').doc(item.id).delete()
      refresh()
    } catch (err) {
      setError("Impossible de supprimer l'admin")
      console.warn(err)
    }
  }

  const onActive = async (item: any, refresh: any) => {
    try {
      await Fire.store().collection('admins').doc(item.id).update({ active: !item.active })
      refresh()
    } catch (err) {
      setError("Impossible de modifier l'admin")
      console.warn(err)
    }
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={'Nos administrateurs'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <FadeIn>

              <ListContainer
                title="Administrateurs"
                searchTitle="Rechercher un admin..."
                createTitle="Créer un admin"
                error={error}
                onFetch={onFetch}
                onCreate={() => history.push('/admin/admin/new')}
                onSelect={(item) => history.push('/admin/admin/' + item.id)}
                sorting={sorting}
                renderColumns={({ refresh }) => ([
                  { name: 'Nom', string: 'name', sortable: true, accessor: 'name' },
                  { name: 'Email', string: 'email', sortable: true, accessor: 'email' },
                  { name: 'Rôle', string: 'role_col', sortable: true, accessor: 'role_col' },
                  { name: 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' },
                ])}
                />

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminsScreen